import data from './pie.data'
import label from './pie.label'
import labelLine from './pie.labelLine'
import itemStyle from './pie.itemStyle'
import tooltip from './pie.tooltip'

export default {
  name: "pie",
  nickname: "饼图",
  desc: "pie",
  type: "object",
  props: {
    startAngle: {
      name: "startAngle",
      nickname: "起始角度",
      desc: "起始角度，支持范围[0, 360]。",
      value: 90,
      defaultValue: 90,
      type: "pureValue",
    },
    center: {
      name: "center",
      nickname: "中心位置",
      desc: "饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。",
      value: ["50%", "50%"],
      defaultValue: ["50%", "50%"],
      type: "pureValue",
    },
    radius: {
      name: "radius",
      nickname: "半径",
      desc: "饼图的半径。可以为如下类型：",
      value: [0, "75%"],
      defaultValue: [0, "75%"],
      type: "pureValue",
    },
    data,
    selectedMode: {
      name: "selectedMode",
      nickname: "选择模式",
      desc:
        '选中模式，表示是否支持多个选中，默认关闭，支持布尔值和字符串，字符串取值可选<code class="codespan">&#39;single&#39;</code>，<code class="codespan">&#39;multiple&#39;</code>，分别表示单选还是多选。',
      value: false,
      defaultValue: false,
    },
    selectedOffset: {
      name: "selectedOffset",
      nickname: "选中扇区的偏移距离",
      desc: "选中扇区的偏移距离。",
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
    roseType: {
      name: "roseType",
      nickname: "是否展示成南丁格尔图",
      desc: "是否展示成南丁格尔图，通过半径区分数据大小。可选择两种模式：",
      value: false,
      defaultValue: false,
    },
    avoidLabelOverlap: {
      name: "avoidLabelOverlap",
      nickname: "是否启用防止标签重叠",
      desc:
        "是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    label,
    labelLine,
    itemStyle,
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
